import axios from "axios";
import { useState } from "react";
import { useTraduction } from "../../Contexte/TraductionContext";

function Newsletter() {
    
    const { contentAccueil } = useTraduction()


    const initialFormData = {
        email: '',
    };

    const [formData, setFormData] = useState(initialFormData);

    const handleInput = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        axios.post('http://localhost:5001/send-email-newsletter', formData)
            .then(response => {
                console.log('Réponse du serveur:', response.data);
                // Réinitialiser le formulaire une fois qu'il est soumis avec succès
                setFormData(initialFormData);
            })
            .catch(error => {
                console.error('Erreur lors de l\'envoi de l\'email:', error);
            });
    };

    
    return <>
    
    <section id="Newsletter" className="mt-124">
        <h3>{contentAccueil.GrosTitreNewsletter}</h3>
        <p className="mt-32">{contentAccueil.DescriptionNewsletter}</p>
        <div className="mt-32">
        <input 
            type="text" 
            placeholder={contentAccueil.PlaceHolderNewsletter} 
            name="email"
            value={formData.email} // Utilisez formData.email ici
            onChange={handleInput}
        />
            <button className="btn-medium btn-red" onClick={handleSubmit}>{contentAccueil.BoutonNewsletter}</button>
        </div>
    </section>
</>
    
}

export default Newsletter